/* Keep policy wording untouched; repair only existing contact and policy links. */
(() => {
  const body = document.querySelector('.shopify-policy__body');
  if (!body) return;

  const storefrontHosts = new Set([
    'sportshub.es', 'www.sportshub.es', 'sportshub.fr', 'www.sportshub.fr',
    'pt.sportshubeurope.com', 'de.sportshubeurope.com',
    'it.sportshubeurope.com', 'nl.sportshubeurope.com',
    'no.sportshubeurope.com', 'be.sportshubeurope.com',
  ]);
  const root = new URL(window.Shopify?.routes?.root || '/', location.origin);
  if (root.origin !== location.origin) return;
  const prefix = root.pathname.replace(/\/$/, '');

  body.querySelectorAll('a').forEach((anchor) => {
    const href = anchor.getAttribute('href');
    if (!href) {
      const text = anchor.textContent.replace(/[\s📧📞]/gu, '');
      if (/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(text)) {
        anchor.setAttribute('href', `mailto:${text}`);
      } else if (/^\+\d{9,15}$/.test(text)) {
        anchor.setAttribute('href', `tel:${text}`);
      }
      return;
    }
    let url;
    try { url = new URL(href, location.href); } catch { return; }
    if (!['http:', 'https:'].includes(url.protocol) || !storefrontHosts.has(url.hostname)) return;
    const policy = url.pathname.match(/\/policies\/(legal-notice|terms-of-service|privacy-policy|shipping-policy|refund-policy|contact-information)\/?$/);
    if (!policy) return;
    anchor.setAttribute('href', `${prefix}/policies/${policy[1]}${url.search}${url.hash}`);
  });
})();
